module.exports = __webpack_public_path__ + "static/9-projects-transforming-the-campus-68059f91b068698f5252e918dbf9f3a0.jpg";